export default [
  // Health Section
  {
    path: '/patients-ui/ping',
    name: 'PingPage',
  },

  // Recalls Section
  {
    path: '/recalls/:recallId',
    name: 'RecallSchedulingPage',
  },

  // Reminders Section
  {
    path: '/reminder-attempts/:reminderAttemptId/confirm',
    name: 'ConfirmRemindersPage',
  },
  {
    path: '/reminder-attempts/:reminderAttemptId/reschedule',
    name: 'RescheduleRemindersPage',
  },

  // Reviews Section
  {
    path: '/reviews/:id/dislike',
    name: 'DislikeReviewPage',
  },
  {
    path: '/reviews/:id/like',
    name: 'LikeReviewPage',
  },
  {
    path: '/reviews/:id',
    name: 'ReviewPage',
  },

  // Widgets Section
  {
    path: '/appointments/:id/cancel',
    name: 'WidgetCancelAppointmentPage',
  },
  {
    path: '/appointments/:id/cancel/widget',
    name: 'WidgetCancelAppointmentPage',
  },
  {
    path: '/appointments/:id/reschedule',
    name: 'WidgetReschedulePage',
  },
  {
    path: '/appointments/:id/reschedule/widget',
    name: 'WidgetReschedulePage',
  },
  {
    path: '/appointments/:id/widget',
    name: 'WidgetAppointmentDetailPage',
  },
  {
    path: '/providers/:providerId/appointments/:id/widget',
    name: 'WidgetAppointmentDetailPage',
  },
  {
    path: '/appointments/:id',
    name: 'WidgetAppointmentDetailPage',
  },
  {
    path: '/providers/:providerId/appointments/:id',
    name: 'WidgetAppointmentDetailPage',
  },
  {
    path: '/practices/:id/widget',
    name: 'WidgetPracticePage',
  },
  {
    path: '/offices/:id/widget',
    name: 'WidgetOfficeSchedulingPage',
  },
  {
    path: '/offices/:id/reviews/widget',
    name: 'WidgetOfficeReviewsPage',
  },
  {
    path: '/providers/:id/widget',
    name: 'WidgetProviderSchedulingPage',
  },
  {
    path: '/providers/:providerId/openings/:openingSlug/widget',
    name: 'WidgetAppointmentFormPage',
  },

  // Main Section
  {
    path: '/appointments/:id/cancel/main',
    name: 'MainCancelAppointmentPage',
  },
  {
    path: '/appointments/:id/reschedule/main',
    name: 'MainReschedulePage',
  },
  {
    path: '/appointments/:id/main',
    name: 'MainAppointmentDetailPage',
  },
  {
    path: '/providers/:providerId/appointments/:id/main',
    name: 'MainAppointmentDetailPage',
  },
  {
    path: '/providers/:providerId/openings/:openingSlug',
    name: 'MainAppointmentFormPage',
  },
  {
    path: '/providers/:id/',
    name: 'MainProviderPage',
  },

  // Payments Section

  {
    path: '/payments/:id/',
    name: 'DIPaymentLandingPage',
  },

  // Scheduling Section

  {
    path: '/scheduling/:id/',
    name: 'DISchedulingPage',
  },

  // Catch-all Not Found Page
  {
    path: '*',
    name: 'NotFoundPage',
  },
];
